import { Polyline } from "react-leaflet";
import _ from "lodash";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

const checkHighlight = (segment_id, sessions, highlighted_route_id) => {
    let isHighlighted = false;
    if (highlighted_route_id !== null) {
        const highlightedSession = sessions[highlighted_route_id];
        if (highlightedSession && highlightedSession.map_segments && highlightedSession.map_segments.length) {
            // Fast binary search is possible here because highlightedSession.map_segments is always in ascending order
            isHighlighted = _.sortedIndexOf(highlightedSession.map_segments, segment_id) !== -1;
        }
    }
    return isHighlighted;
};

const sessionsSelector = (state) => state.sessions;
const highlightedRouteIDSelector = (state) => state.highlightedRouteID;

export const HighlightedMapGeometry = ({ mapGeom }) => {
    const sessions = useSelector(sessionsSelector);
    const highlightedRouteID = useSelector(highlightedRouteIDSelector);

    const highlightedMapSegments = useMemo(() => {
        if (!highlightedRouteID) {
            return [];
        }
        return mapGeom.filter((geom) => {
            return checkHighlight(geom.id, sessions, highlightedRouteID);
        });
    }, [highlightedRouteID, mapGeom, sessions]);

    const getGeometry = (points) => {
        return points.map((point) => {
            return [point[2], point[1], point[0]];
        });
    };

    const mapLines = useMemo(() => {
        return highlightedMapSegments.map((segment) => {
            const geometry = getGeometry(segment.points);
            return (
                <>
                    <Polyline
                        color={"#6C43DF"}
                        weight={4}
                        opacity={1}
                        positions={geometry}
                    />
                </>
            );
        });
    }, [highlightedMapSegments]);

    return mapLines;
};
